module.exports = __webpack_public_path__ + "static/media/logo-noBg.2927560c.svg";